// src/routes/Web.js  (or WebsiteRoutes.js depending on your file name)

import HomePage from "../pages/web/HomePage";
import Property from "../pages/web/Property";
import AboutPage from "../pages/web/AboutPage";
import ContactPage from "../pages/web/ContactPage";
import PropertyDetails from "../pages/web/PropertyDetails";

const Web = [
  { path: "/", element: <HomePage /> },
    { path: "/home", element: <HomePage /> },
  { path: "/Property", element: <Property /> },
  { path: "/property/:id", element: <PropertyDetails /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/contact", element: <ContactPage /> },

];

export default Web;
